/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  useMemo,
} from 'react';

import type {
  StylesConfig,
} from 'react-select';

import {
  useTheme,
} from 'styled-components';

import {
  inputDefault,
  inputSmall,
} from './input';
import {
  loadingIndicator,
} from './loadingIndicator';
import {
  createMultiValueStyle,
} from './multiValue';
import {
  createMultiValueLabelStyle,
} from './multiValueLabel';
import {
  createPlaceholderStyle,
} from './placeholder';
import {
  createValueContainerStyle,
} from './valueContainer';
import {
  createSingleValueStyle,
} from './singleValue';
import {
  createOptionStyle,
} from './option';
import {
  createMenuStyle,
} from './menu';

export const useStyles = (
  isSmall: boolean,
) => {
  const theme = useTheme();

  const styles = useMemo<StylesConfig<any, any, any>>(() => ({
    input: isSmall ? inputSmall : inputDefault,
    loadingIndicator,
    menu: createMenuStyle(theme),
    multiValue: createMultiValueStyle(theme),
    multiValueLabel: createMultiValueLabelStyle(theme),
    option: createOptionStyle(theme),
    placeholder: createPlaceholderStyle(theme),
    singleValue: createSingleValueStyle(theme),
    valueContainer: createValueContainerStyle(isSmall, theme),
  }), [
    isSmall,
    theme,
  ]);

  return styles;
};
